export enum BpiType {
    AUDAX = 'AUDAX',
    X21 = 'X21',
    LIST = 'LIST',
    MEDIFIT = 'MEDIFIT',
    SEPARATED = 'SEPARATED',
    PAPP = 'PAPP',
    HELIANT = 'HELIANT',
    NOVA_VIZIJA = 'NOVA_VIZIJA',
    E_ORDINACIJA = 'E_ORDINACIJA',
}
